import React from "react";
import { LeadForm } from "./LeadForm";

export const LeadFormSection = ({ onScheduleClick }) => {
  return (
    <section
      id="consultation"
      data-testid="consultation-section"
      className="relative py-24 sm:py-32 border-t border-white/5 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="text-[11px] tracking-[0.2em] uppercase text-[#D4AF37] mb-4">
            Book a Free Consultation
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-light text-white">
            Tell me about your <span className="gold-text italic">business.</span>
          </h2>
          <p className="mt-6 text-[#B0B0B0]">
            Four short steps, two minutes. I'll personally review it and come back
            with honest advice + a clear plan — even if we don't end up working together.
          </p>
          <ul className="mt-8 space-y-3 text-sm text-[#B0B0B0]">
            <li>· No pushy sales calls.</li>
            <li>· Free 30-min strategy session.</li>
            <li>· Clear, fixed quote within 24 hours.</li>
          </ul>
          {onScheduleClick && (
            <button
              data-testid="leadform-calendly"
              onClick={onScheduleClick}
              className="mt-8 inline-flex items-center gap-2 text-sm text-[#D4AF37] hover:text-[#E6C35C] transition-colors"
            >
              Prefer to pick a time on a calendar? →
            </button>
          )}
        </div>
        <div className="lg:col-span-7">
          <LeadForm />
        </div>
      </div>
    </section>
  );
};
